export enum LoyaltyPartnerTypeEnum {
    DOWNLOAD_ASSET = 'a',
    EXPERIENCE_MAJOR_FINAL = 'e',
    LIMITED_DISCOUNT = 'd',
    OPTIN = 'o',
    VOUCHER = 'v',
}
